// ******************** Plans of control *************************
// GET
export const GET_PLANS_CONTROL = "GET_PLANS_CONTROL"
export const GET_PLANS_CONTROL_SUCCESS = "GET_PLANS_CONTROL_SUCCESS"
// POST
export const POST_PLAN_CONTROL = "POST_PLAN_CONTROL"
export const DUPLICATE_PLAN_CONTROL = "DUPLICATE_PLAN_CONTROL"
// PATCH
export const PATCH_PLAN_CONTROL = "PATCH_PLAN_CONTROL"
// DELETE
export const DELETE_PLAN_CONTROL = "DELETE_PLAN_CONTROL"

// ******************** CONTROLS*************************
// GET
export const GET_ALL_CONTROL_PLANS_AND_CONTROLS = "GET_ALL_CONTROL_PLANS_AND_CONTROLS"
export const GET_ALL_CONTROL_PLANS_AND_CONTROLS_SUCCESS =
  "GET_ALL_CONTROL_PLANS_AND_CONTROLS_SUCCESS"
export const GET_CONTROL_PLAN_AND_CONTROLS = "GET_CONTROL_PLAN_AND_CONTROLS"
export const GET_CONTROL_PLAN_AND_CONTROLS_SUCCESS = "GET_CONTROL_PLAN_AND_CONTROLS_SUCCESS"
export const GET_CONTROL_AND_TEMPLATE_BY_ID = "GET_CONTROL_AND_TEMPLATE_BY_ID"
export const GET_CONTROL_AND_TEMPLATE_BY_ID_SUCCESS = "GET_CONTROL_AND_TEMPLATE_BY_ID_SUCCESS"
export const GET_CONTROLS_THAT_HAVE_RECOMMENDATIONS = "GET_CONTROLS_THAT_HAVE_RECOMMENDATIONS"
export const GET_CONTROLS_THAT_HAVE_RECOMMENDATIONS_SUCCESS =
  "GET_CONTROLS_THAT_HAVE_RECOMMENDATIONS_SUCCESS"
export const SET_CONTROLS_THAT_HAVE_RECOMMENDATIONS = "SET_CONTROLS_THAT_HAVE_RECOMMENDATIONS"
export const GET_OVERALL_SYNTHESE_CONTROL = "GET_OVERALL_SYNTHESE_CONTROL"
export const GET_OVERALL_SYNTHESE_CONTROL_SUCCESS = "GET_OVERALL_SYNTHESE_CONTROL_SUCCESS"
// POST
export const POST_CONTROL = "POST_CONTROL"
export const DUPLICATE_CONTROL = "DUPLICATE_CONTROL"
// PATCH
export const PATCH_CONTROL_99 = "PATCH_CONTROL_99"
export const PATCH_CONTROL_FROM_PLANNING_CONTROL = "PATCH_CONTROL_FROM_PLANNING_CONTROL"
export const AFFECT_USERS_CONTROL = "AFFECT_USERS_CONTROL"
// DELETE
export const DELETE_CONTROL = "DELETE_CONTROL"
// FILES
export const POST_FILES_CONTROL = "POST_FILES_CONTROL"
export const POST_FILES_CONTROL_SUCCESS = "POST_FILES_CONTROL_SUCCESS"
export const DELETE_FILES_CONTROL = "DELETE_FILES_CONTROL"
export const DELETE_FILES_CONTROL_SUCCESS = "DELETE_FILES_CONTROL_SUCCESS"
export const CLEAN_FILES_CONTROL = "CLEAN_FILES_CONTROL"
// ******************** CONTROL POINTS*************************
// GET
export const GET_CONTROL_POINTS = "GET_CONTROL_POINTS"
// POST
export const POST_CONTROL_POINT = "POST_CONTROL_POINT"
export const DUPLICATE_CONTROL_POINT = "DUPLICATE_CONTROL_POINT"
// PATCH
export const PATCH_CONTROL_POINT = "PATCH_CONTROL_POINT"
// DELETE
export const DELETE_CONTROL_POINT = "DELETE_CONTROL_POINT"

// ******************** CONTROL THREAD DISCUSSION*************************
export const GET_CONTROL_THREAD_BY_CONTROL_ID = "GET_CONTROL_THREAD_BY_CONTROL_ID"
export const GET_CONTROL_THREAD_BY_CONTROL_ID_SUCCESS = "GET_CONTROL_THREAD_BY_CONTROL_ID_SUCCESS"
export const POST_MESSAGE_CONTROL_THREAD = "POST_MESSAGE_CONTROL_THREAD"

// ******************** VALIDATION CONTROLS PARAMETERS AND TEMPLATE WORKFLOW 99*************************
export const CONFIRM_CONTROL_VALIDATION = "CONFIRM_CONTROL_VALIDATION"

// ******************** VALIDATION CONTROLS IN PLANNING*************************
export const MANAGER_VALID_CONTROL = "MANAGER_VALID_CONTROL"
export const MANAGER_REJECT_CONTROL = "MANAGER_REJECT_CONTROL"
export const CLIENT_VALID_CONTROL = "CLIENT_VALID_CONTROL"
export const CLIENT_REJECT_CONTROL = "CLIENT_REJECT_CONTROL"

// ******************** REGROUP REQUEST CONTROL / RESPONSES / DOCUMENTS / THREAD *************************
export const GET_ALL_DATAS_CONTROL_PLANNING_V2 = "GET_ALL_DATAS_CONTROL_PLANNING_V2"
export const SET_IS_LOADING_CONTROL = "SET_IS_LOADING_CONTROL"
export const SET_IS_LOADING_SYNTHESE = "SET_IS_LOADING_SYNTHESE"
